import { RenderModalCtx } from 'datocms-plugin-sdk';
import { Canvas } from 'datocms-react-ui';
import GraphEditor from './GraphEditor';
import { GraphQLClient } from 'graphql-hooks';
import useGQLQueryWithClient from '../../hooks/useGQLQueryWithClient';
import { ChatNode, getDialogNodes } from './queries';

type PropTypes = {
  ctx: RenderModalCtx;
};


export default function RenderChatEditorModal({ctx} : PropTypes) {
  const client = new GraphQLClient({
    url: "https://graphql.datocms.com/",
    headers: {
      "Authorization": `Bearer c2637bf4c3ca322961249cf1b65310`, // Todo use user token
      "X-Include-Drafts": "true",
    }
  });
    
  const dialogContent = ctx.parameters.dialogContent as any;
  const id = ctx.parameters.id as string;

  const { loading, error, data} = useGQLQueryWithClient(client, getDialogNodes(id));

  if (loading) return <div>Loading dialog graph...</div>
  if (error) return <div>Error while loading dialog graph...</div>

  console.log(data);

  const nodes = (data.data as any).allChatNodes as ChatNode[];
  console.log(nodes);

  const graphNodes : {id: string, data: {label: string}, position: {x: 0, y : 0}}[] = [];
  const graphEdges : {id: string, source: string, target: string, animated: true, label? : string}[] = [];
  

  // Validate chat nodes and convert them to graph
  const nodeIds = new Set<string>();
  for (const node of nodes) {
    nodeIds.add(node.id);
  }

  for (const node of nodes) {
    console.log(node.title);
    graphNodes.push({id: node.id, data: {label: node.title}, position: {x: 0, y: 0}});
    if (node.nodeType == "text") {
      if (node.nextNodes.length != node.answers.length || node.nextNodes.length != node.labels.length ) {
        return <div>The node {node.title} differs in length of next nodes and answers.</div>
      }
      for (const index in node.nextNodes) {
        const {id: targetId} = node.nextNodes[index];
        const {text: label} = node.labels[index];

        if (!nodeIds.has(targetId)) {
          return <div>The node {node.title} points to a node to an other nodeId ({targetId}) </div>
        }
        graphEdges.push({
          id: node.id+"&"+targetId,
          source: node.id,
          target: targetId,
          animated: true,
          label,
        })
      }
    } else if (node.nodeType == "article") {
      if (node?.nextNode?.id !== undefined && !nodeIds.has(node.nextNode.id)) {
        return <div>The node {node.title} points to a node to an other nodeId ({node?.nextNode?.id}) </div>
      }
      if (node.nextNode) {
        graphEdges.push({
          id: node.id+"&"+node.nextNode.id,
          source: node.id,
          target: node.nextNode.id,
          animated: true,
          label: "Article"
        })
      }
    }
  }
  
  return <Canvas ctx={ctx}>
    <GraphEditor
      graphNodes = {graphNodes}
      graphEdges = {graphEdges}
    />
  </Canvas>
}